import React from 'react';
import { Card } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { roleUrl, userUrl } from '@/constants/urls';
import CardItem from '@/components/cards/CardItem';
import LinkifyWrapper from '@/components/LinkifyWrapper';
import NameDescriptionCard from '@/components/cards/NameDescriptionCard';
import userStatusMessage from '../helper';
import { userIcon } from '../constants';
import UserTools from '../containers/UserTools';

const UserCardItem = ({
  allowApprovedStatus,
  allowRoleLink,
  allowUserLink,
  allowTools,
  category,
  onCheckBoxClick,
  single,
  user,
  upward,
}) => {
  const intl = useIntl();
  const item = userIcon(user);

  return (
    <CardItem className="aridhia-user-card-item" error={user.archived} warning={!user.archived && !user.approved}>
      <NameDescriptionCard
        description={user.role?.name}
        descriptionHref={user.role && allowRoleLink ? roleUrl(user.role) : undefined}
        error={user.archived}
        icon={item.icon}
        iconColour={item.color}
        iconMessage={item.message}
        link={allowUserLink ? userUrl(user) : undefined}
        meta={allowApprovedStatus ? intl.formatMessage({ id: userStatusMessage(user) }) : undefined}
        onSelect={onCheckBoxClick ? () => onCheckBoxClick(user.code) : undefined}
        name={user.name}
        selected={user.selected}
        single={single}
      >
        {allowTools && (
        <UserTools
          iconSize="large"
          url={userUrl(user, '#')}
          upward={upward}
          category={category}
          user={user}
          listItem
        />
        )}
      </NameDescriptionCard>
      {user.email && (
        <Card.Content extra>
          <LinkifyWrapper>
            {user.email}
          </LinkifyWrapper>
        </Card.Content>
      )}
    </CardItem>
  );
};

export default UserCardItem;
